import { fork, select, takeLatest, put } from 'redux-saga/effects'
import { sagas as patients } from './Patients'
import { sagas as careteam } from './Careteam'
import { sagas as careplan } from './Careplan'
import { sagas as goal } from './Goal'
import { sagas as group } from './Group'
import { sagas as observations } from '@medeo/observations'
import { sagas as documents } from './Documents'
import { sagas as logIn, LOGGED_IN, getAccessToken } from '@medeo/user'
import { push } from 'react-router-redux'
import { decode } from 'jsonwebtoken'
import moment from 'moment'

export default function* rootSaga() {
  yield takeLatest(LOGGED_IN, watchLoggedIn)
  yield fork(logIn)
  const accessToken = yield select(getAccessToken)

  if (shouldLogIn(accessToken)) {
    yield put(push('/login'))
  } else {
    yield watchLoggedIn()
  }
}

function shouldLogIn(accessToken) {
  if (accessToken == null) return true
  const { exp } = decode(accessToken)
  const currentTime = moment().unix()
  return exp - currentTime < 0
}

function* watchLoggedIn() {
  yield fork(patients)
  yield fork(observations)
  yield fork(careteam)
  yield fork(careplan)
  yield fork(goal)
  yield fork(documents)
  yield fork(group)
  yield put(push({ pathname: '/', state: {} }))
}



// WEBPACK FOOTER //
// ./src/sagas.js